export default "__VITE_ASSET__1bZSYtpB__"